<template>
  <td class="px-1 py-2 text-sm text-gray-500 sm:max-w-xs lg:max-w-lg pr-5">
    <AgentAvatar v-bind:agent="agent" diameter="44" classes="inline-block -space-x-2 relative z-0 overflow-hidden" />
  </td>
  <td class="px-1 py-1 text-sm text-gray-500 w-full">
    {{agent.attributes.name}}
  </td>
  <td class="px-1 py-1 text-sm text-gray-500">
    <XIcon v-on:click="removeAgent" class="-ml-1 mr-2 h-5 w-5 cursor-pointer" />
  </td>
</template>

<script>
import AgentAvatar from '../../agents/AgentAvatar.vue'
import { XIcon } from '@heroicons/vue/outline'

export default {
  name: 'GroupAgentItem',
  props: ['agent'],
  emits: ['remove-agent'],
  components: {
    AgentAvatar,
    //
    XIcon,
  },
  methods: {
    removeAgent() {
      this.$emit('remove-agent', this.agent);
    }
  },
}
</script>
